
import ViewJournaldetail from "../../components/componentallistallpprovebyuser/viewJournaldetail";

export const columns = [
    {
        name: 'No',
        selector: row => row.num,
        grow: 0.2,
    },
        {
        name: 'E-TDS',
        selector: row => row.tdscode,
        grow: 0.7,
        sortable: true,
    },
    {
        name: 'Date',
        selector: row => row.createdate,
        grow: 0.7,
    },
        {
        name: 'Approved Confirm',
        selector: row => row.dateconfirm,
        grow: 0.7,
    },
    {
        name: 'FormName',
        selector: row => row.formName,
        grow: 0.7,
    },
    {
        name: 'Product Type',
        selector: row => row.productgrouptype,
        grow: 0.7,
    },
    {
        name: 'Item Id',
        selector: row => row.itemcode,
        grow: 0.7,
        sortable: true,
    },
    {
        name: 'Product Name',
        selector: row => row.productname,
        grow: 0.7,
    },
    {
        name: 'Film Code',
        selector: row => row.filmcode,
        grow: 0.7,
        sortable: true,
    },
    // {
    //     name: 'Customer Name',
    //     selector: row => row.customername,
    //     grow: 0.7,
    // },
    // {
    //     name: 'CanSize',
    //     selector: row => row.cansize,
    //     grow: 0.7,
    //     sortable: true,
    // },
    // {
    //     name: 'Shape',
    //     selector: row => row.shape,
    //     grow: 0.7,
    // },
    // {
    //     name: 'Sheet Size',
    //     selector: row => row.sheetsize,
    //     grow: 0.7,
    // },
    // {
    //     name: 'Workproved',
    //     selector: row => row.workprove,
    //     grow: 0.7,
    // },
    // {
    //     name: 'Printing Machine',
    //     selector: row => row.printingmachine,
    //     grow: 0.7,
    //     sortable: true,
    // },
    // {
    //     name: 'Coating',
    //     selector: row => row.coating,
    //     grow: 0.7,
    // },
    {
        name: 'Sale',
        selector: row => row.SaleName,
        grow: 0.7,
    },
    {
        name: 'Status Approved',
        selector: row => row.statusapproved,
        grow: 0.7,
    },
           {
        name: 'Approved By',
        selector: row => row.nameapproved,
        grow: 0.7,
    },
    {
        name: 'View',
        grow: 0.5,
        selector: row => <div><ViewJournaldetail jourId={row.journalId} codeId={row.tdscode}/></div>,
    },

];

export const headersexcel = [
    { label: "On", key: "num" },
    { label: "Date", key: "createdate" },
    { label: "Date approved", key: "dateconfirm" },
    { label: "FormName", key: "formName" },
    { label: "E-TDS", key: "tdscode" },
    { label: "Product Type", key: "productgrouptype" },
    { label: "Item Code", key: "itemcode" },
    { label: "Product Name", key: "productname" },
    { label: "Film Code", key: "filmcode" },
    { label: "Customer Name", key: "customername" },
    { label: "Cansize", key: "cansize" },
    { label: "Shape", key: "shape" },
    { label: "Sheetsize", key: "sheetsize" },
    { label: "Workprove", key: "workprove" },
    { label: "Printingmachine", key: "printingmachine" },
    { label: "Coating", key: "coating" },
    { label: "SaleName", key: "SaleName" },
    { label: "Status Approved", key: "statusapproved" },
     { label: "Name Approved", key: "nameapproved" },
];